import {APIError} from '../core/errors';
import httpClient from '../services/http.service';
import {BASE_URL, DEFAULT_HEADERS} from './api-constants';
//TODO: To be removed later;
// const mockResponse = {
//   tier: 'EDGE',
//   message: 'SUCCESS',
//   firstName: 'NIRMALA NAGESH',
//   redirectUrl:
//     'https://www.lifestylestores.com/in/en/c/accessories-women-fashionjewellery?q=badge.title.en%3ANew%3Abadge.title.en%3AExclusive',
//   pointsAvailable: 46.16,
//   pointsToExpire: 0,
//   firstScan: null,
//   date: '10-06-2021',
//   keyId: 'LnLfNgrTmnQrc0047',
//   benefit: null,
//   firstLogin: 'yes',
//   showEdge: false,
//   customerCoupons: [
//     {
//       customerCouponId: 1408755,
//       mobileNumber: '9980933471',
//       couponGeneratedTime: '2021-06-10 15:43:32',
//       couponCode: '2L885CD',
//       description:
//         "1_.  EXCLUSIVE OFFER! Get Extra 10% on    Women's Ethnic wear   Use above code at     Lifestyle stores. ",
//       validity: '2021-06-17 23:59:59',
//       keyId: 'LnLfNgrTmnQrc0047',
//       couponType: 'LSWAPA',
//       regionId: '94',
//       detailsId: 300,
//     },
//   ],
//   spinWheelPoints: null,
//   interactionBenefit: null,
//   resultType: 'CAPILLARY',
// };
const mockResponse = {
  response: {
    tier: 'NON-EDGE',
    message: 'SUCCESS',
    firstName: 'SONAKSHI NA',
    redirectUrl:
      'https://www.lifestylestores.com/in/en/c/women-bottoms-jeansandjeggings?q=badge.title.en%3ANew%3Abadge.title.en%3AExclusive',
    pointsAvailable: 3.61,
    pointsToExpire: 0,
    firstScan: null,
    date: '28-07-2021',
    keyId: 'LnLfBngOacQrc0017',
    benefit: null,
    firstLogin: null,
    showEdge: false,
    customerCoupons: [
      {
        customerCouponId: 1467556,
        mobileNumber: '9540390487',
        couponGeneratedTime: '2021-07-28 16:53:35',
        couponCode: 'WJUAAQ',
        description: '100 off test',
        validity: '2021-07-31 23:59:59',
        keyId: 'LnLfBngOacQrc0017',
        couponType: 'LSWAPA',
        regionId: '26',
        detailsId: 0,
      },
    ],
    spinWheelPoints: null,
    resultType: 'CAPILLARY',
    interactionBenefit: null,
  },
  code: 200,
  message: 'Success',
  version: '1',
};
const _api_base_url = `${BASE_URL}/lmr/getCouponDetails`;

const _api_base_url_couponpoints = `${BASE_URL}/lmr/get-points`;

interface coupon {
  couponCode: string;
  couponDesc: string;
  validTillDate: string;
}

interface offerResponse {
  result: boolean;
  resultCode: string;
  message: string;
  mobileNumber: string;
  couponList: coupon[];
}

interface CustomerCoupon {
  customerCouponId: number;
  mobileNumber: string;
  couponGeneratedTime: string;
  couponCode: string;
  description: string;
  validity: string;
  keyId: string;
  couponType: string;
  regionId: string;
  detailsId: number;
}
interface CouponPointsResponse {
  tier: string | null;
  message: string;
  firstName: string | null;
  redirectUrl: string | null;
  pointsAvailable: number;
  pointsToExpire: number;
  firstScan: null;
  date: string | null;
  keyId: string | null;
  benefit: null;
  firstLogin: string | null;
  showEdge: boolean;
  customerCoupons: CustomerCoupon[] | null;
  spinWheelPoints: null;
  interactionBenefit: null;
  resultType: string;
}

interface OfferRequest {
  payload: {
    mobileNumber: string | null;
    ouCode: string | null;
  };
  accessToken: string | null;
}
interface CouponPointsRequest {
  accessToken: string | null;
  payload: {
    keyId: string | null;
    storecode?: string | null;
  };
}

export const getOffers = async (
  parameters: OfferRequest,
): Promise<offerResponse> => {
  try {
    //const req = JSON.stringify(requestBody);
    const response = await httpClient.post(
      `${_api_base_url}`,
      parameters.payload,
      {
        headers: {
          ...DEFAULT_HEADERS,
          Authorization: `Bearer ${parameters.accessToken}`,
        },
      },
    );
    return response.data;
  } catch (error) {
    throw new APIError(error);
  }
};

export const getCouponPoints = async (
  parameters: CouponPointsRequest,
): Promise<CouponPointsResponse> => {
  try {
    //const req = JSON.stringify(parameters.payload);
    const response = await httpClient.post(
      `${_api_base_url_couponpoints}`,
      parameters.payload,
      {
        headers: {
          ...DEFAULT_HEADERS,
          Authorization: `Bearer ${parameters.accessToken}`,
        },
      },
    );
    //return mockResponse.response;
    return response.data.response;
  } catch (error) {
    throw new APIError(error);
  }
};
